import { useEffect } from "react";
import Router from "./routes/router";
import { QueryClientProvider } from "@tanstack/react-query";
import CreatePostPopup from "./components/posts/CreatePostPopup";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import Portal from "./utils/Portal";
import ErrorBoundary from "./components/ErrorBoundary";
import { useBranding } from "./hooks/useBranding";
import { LanguageProvider } from "./context/LanguageContext";
import { ConfirmDialogProvider } from "./components/UI/ConfirmDialog";
import { queryClient } from "./services/queryClient";

// The client itself lives in services/queryClient.js so services/api.js can
// clear it on logout without a circular import; re-exported for the many
// `import { queryClient } from "../App"` call sites.
export { queryClient };

function BrandingLoader() {
  useBranding();
  return null;
}

function App() {
  const user = useSelector((state) => ({ ...state.user.userinfo }));
  const createPost = useSelector((state) => state.createPost);

  useEffect(() => {
    if (createPost.isOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
    }
  }, [createPost.isOpen]);

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <LanguageProvider>
          <ConfirmDialogProvider>
            <BrandingLoader />
            {createPost.isOpen && <CreatePostPopup user={user} />}
            <Portal>
              <Toaster position="bottom-left" reverseOrder={false} />
            </Portal>
            <Router />
          </ConfirmDialogProvider>
        </LanguageProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
